"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteFilterDto = exports.ByOptionalFacilityIdDto = exports.UpdateFiltersDto = exports.UpdateFilterDto = exports.CreateFilterDto = exports.BaseFilterValuesDto = exports.UserDefaultFiltersDto = exports.FilterDto = exports.GetPaginatedFilterOptionsDto = exports.ByUserAndFilterDto = exports.ByOrganizationUserIdDto = exports.ByFilterIdDto = exports.ByOrganizationFilterDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class ByOrganizationFilterDto {
}
exports.ByOrganizationFilterDto = ByOrganizationFilterDto;
class ByFilterIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByFilterIdDto = ByFilterIdDto;
class ByOrganizationUserIdDto extends ByOrganizationFilterDto {
}
exports.ByOrganizationUserIdDto = ByOrganizationUserIdDto;
class ByUserAndFilterDto extends ByOrganizationUserIdDto {
}
exports.ByUserAndFilterDto = ByUserAndFilterDto;
class GetPaginatedFilterOptionsDto extends general_dto_1.PaginationQuery {
}
exports.GetPaginatedFilterOptionsDto = GetPaginatedFilterOptionsDto;
class FilterDto {
}
exports.FilterDto = FilterDto;
class UserDefaultFiltersDto {
}
exports.UserDefaultFiltersDto = UserDefaultFiltersDto;
class BaseFilterValuesDto {
}
exports.BaseFilterValuesDto = BaseFilterValuesDto;
class CreateFilterDto extends BaseFilterValuesDto {
}
exports.CreateFilterDto = CreateFilterDto;
class UpdateFilterDto {
}
exports.UpdateFilterDto = UpdateFilterDto;
class UpdateFiltersDto {
}
exports.UpdateFiltersDto = UpdateFiltersDto;
class ByOptionalFacilityIdDto {
}
exports.ByOptionalFacilityIdDto = ByOptionalFacilityIdDto;
class DeleteFilterDto extends ByOptionalFacilityIdDto {
}
exports.DeleteFilterDto = DeleteFilterDto;
//# sourceMappingURL=filters.dto.js.map